import React from 'react'
import { getImages } from '../const'

const ChatList = ({convoData, openChat, setNewGroup, setNewChat}) => {
    return (
        <>
            <div className="chatlist p-0">
                <div className="chat-header">
                    <div className="msg-search w-100">
                        <div className="position-relative search-input">
                            <input type="text" className="form-control" placeholder="Search" />
                            <span className="gray-search-icon"></span>
                        </div>
                        <div className="btn-group chat-dropdown">
                            <button className="add" type='button' data-bs-toggle="dropdown" aria-expanded="false">
                                <img className="img-fluid" src={getImages('icon-add.svg')} alt="add" />
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li><button onClick={()=> {setNewGroup(true);}} className="dropdown-item" type="button">New Group</button></li>
                                <li><button onClick={()=> {setNewChat(true);}} className="dropdown-item" type="button">New Chat</button></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-body p-0">
                            <div className="chat-lists">
                                <div className="chat-list">
                                    {convoData.map((item, index) =>
                                        <div key={index}>
                                            <button type="button" className='d-flex w-100' onClick={() => openChat(index)}>
                                                <div className="flex-shrink-0">
                                                    <span className='user-icon'><img src={getImages('icon-chat-user.svg')} alt="user" /></span>
                                                </div>
                                                <div className="flex-grow-1 ms-3 pt-2">
                                                    <h3>{item.friendly_name} <span className={`status-circle ${item.status === "online" ? "green" : "red"}`}></span></h3>
                                                    <p>{item.designation}</p>
                                                </div>
                                                <div className='flex-grow-1 text-end pt-2'>
                                                    <div className='chat-time mb-1'>{item.chattime}</div>
                                                    {item.msgcount > 0 && <div className='unread-count'>{item.msgcount}</div>}
                                                </div>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChatList